module.exports = __webpack_public_path__ + "img/1080_26.429aef7b.jpg";